import PropTypes from 'prop-types';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
// reactstrap components
import {
  Col,
  Container,
  Nav,
  Navbar,
  NavItem,
  Row,
  UncontrolledCollapse,
} from 'reactstrap';

import PromotionWingmanBrandLogo from '../../../assets/img/brand/logo.png';
import PromotionWingmanBrand from '../../../assets/img/brand/pw-logo-horizontal-color-light.svg';
import RootNavbarMobile from './RootNavbarMobile';

class RootNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
    };
  }

  handleTogglerClick = () => {
    this.setState(
      {
        collapse: !this.state.collapse,
      },
      this.props.handleOnColapsedMenu,
    );
  };

  render() {
    return (
      <>
        <div>
          <div
            id="hide"
            className={this.state.collapse === false ? 'hide' : 'show'}
          >
            <RootNavbarMobile
              handleTogglerClick={this.handleTogglerClick}
              collapse={this.state.collapse}
            />
          </div>

          <Navbar
            className={
              this.state.collapse
                ? 'd-none'
                : 'navbar-top navbar-horizontal navbar-dark navbar-color pt-sm-0 pb-sm-0 pt-md-2 pb-md-2 pr-0 pl-0'
            }
            expand="lg"
          >
            <Container className="navbar-container px-4 pl-0 ml-0 mr-0 ml-md-auto mr-md-auto">
              <a href="https://promotionwingman.com">
                <img
                  height="64"
                  width="223.77"
                  className="promotionwingman-img-login w-auto"
                  style={{ height: '4rem' }}
                  src={PromotionWingmanBrand}
                  alt="Promotion Wingman brand"
                />
              </a>
              <div>
                <button
                  className="navbar-toggler pt-0 pb-0 border border-0 pr-0"
                  onClick={this.handleTogglerClick}
                >
                  <i className="icon-notes options-icon" />
                </button>
              </div>

              <UncontrolledCollapse
                navbar
                toggler="#navbar-collapse-main"
                style={{ height: '100%' }}
              >
                <div className="navbar-collapse-header d-md-none">
                  <Row>
                    <Col className="collapse-brand" xs="6">
                      <Link to="/">
                        <img
                          alt="..."
                          src={PromotionWingmanBrandLogo}
                          height="64"
                          width="64"
                        />
                      </Link>
                    </Col>

                    <Col className="collapse-close" xs="6">
                      <button
                        className="navbar-toggler"
                        id="navbar-collapse-main"
                      >
                        <span />
                        <span />
                      </button>
                    </Col>
                  </Row>
                </div>

                <Nav className="ml-auto" navbar>
                  <NavItem>
                    <NavLink className="nav-link-icon" to="/support" tag={Link}>
                      <span className="nav-link-inner--text navbar-options">
                        Support
                      </span>
                    </NavLink>
                  </NavItem>

                  {!(
                    window.location.href.includes('signup') ||
                    window.location.href.includes('sign-up')
                  ) &&
                    !window.location.href.includes('maintenance') && (
                      <NavItem>
                        <NavLink
                          className="nav-link-icon"
                          to="/auth/sign-up"
                          tag={Link}
                          data-test="sign-up-button"
                        >
                          <span className="btn-primary btn-primary-login pl-4 pr-4 pt-2">
                            Sign Up
                          </span>
                        </NavLink>
                      </NavItem>
                    )}

                  {!window.location.href.includes('maintenance') && (
                    <NavItem>
                      <NavLink
                        className="nav-link-icon login-icon pb-2"
                        to="/login"
                        tag={Link}
                      >
                        <i className="icon-profile person-icon-style mr-0" />

                        <span className="nav-link-inner--text--login">
                          LOGIN
                        </span>
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
              </UncontrolledCollapse>
            </Container>
          </Navbar>
          <div className="gradient-divider d-md-none" />
        </div>
      </>
    );
  }
}

RootNavbar.propTypes = {
  handleOnColapsedMenu: PropTypes.func.isRequired,
};

export default RootNavbar;
